import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client';

const GET_EVENT_DETAILS_QUERY = gql`
  query getDitEventDetails($id: ID!) {
    ditEventDetails(id: $id) {
      id
      message
      countryIsoCode
      sourceTypeId
      status
      timestamp
      updatedAt
      username
      fileNormalizationProgress
      ingestionProgress
      source {
        name
        fileSpecs
        url
        description
      }
      sourceFiles {
        filename
        s3Bucket
        s3FileKey
      }
      results {
        s3Bucket
        s3FileKey
      }
    }
  }
`;

export const useDitGetEventDetails = (id) => {
  const { data, loading, error, refetch } = useQuery(GET_EVENT_DETAILS_QUERY, {
    variables: { id },
    notifyOnNetworkStatusChange: true,
  });

  return {
    eventDetails: data?.ditEventDetails,
    loading,
    error,
    refetch,
  };
};
